import { render, staticRenderFns } from "./App.vue?vue&type=template&id=38ced482&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "swiper/css/swiper.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "@/assets/scss/style.scss?vue&type=style&index=2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports